const hasSlider = document.querySelector('.js-cases-slider__slider .swiper');

if (hasSlider) {
	Promise.all([
		import('swiper'),
		import(
			/* webpackExports: ["Navigation"] */
			'swiper/modules'
		),
	])
		.then(([{ default: Swiper }, { Navigation }]) => {
			const swiper = new Swiper('.js-cases-slider__slider .swiper', {
				slidesPerView: 'auto',
				navigation: {
					prevEl: '.js-cases-slider__slider-arrow-left',
					nextEl: '.js-cases-slider__slider-arrow-right',
				},
				modules: [Navigation],
			});
		})
		.catch((err) => console.error(err));
}
